import { styled } from '@vw-marketing/us-components';

export const BaseInformationContainer: any = styled.div`
  margin-top: 60px;
`;

export const CustomParagraphContainer: any = styled.div`
  margin-bottom: 30px;

  button {
    text-align: left;
  }
`;

export const ArrowContainer: any = styled.span`
  font-size: 10px;
`;

export const LinkTextContainer: any = styled.span`
  border-bottom: solid 1px #001e50;
`;

export const DividerLine: any = styled.div`
  width: 100%;
  margin-bottom: 30px;
  border-bottom: solid 1px #dfe4e8;
`;
